export default __webpack_public_path__ + "static/media/logodiadunjbg.e36749cd.png";